import React, { useState, useEffect, useCallback } from 'react';

import { Facet, FacetFilter } from '../../../@types/Search';
import { getHexColorFromDisplayName } from '../../../utils/converter/colorConverter';
import ColorSelect from '../../../StyledComponents/ColorSelect';

interface ColorFilterProps {
  facet: Facet;
  loading?: boolean;
  onFilterUpdate: (query: string) => void;
}

const ColorFilter = ({ facet, loading, onFilterUpdate }: ColorFilterProps) => {
  const [selected, setSelected] = useState<{ [key: string]: boolean }>();

  useEffect(() => {
    if (!loading) {
      setSelected(undefined);
    }
  }, [loading]);

  const onClick = useCallback(
    (f: FacetFilter) => {
      if (!loading) {
        setSelected({
          ...selected,
          [f.displayName]: !f.selected,
        });
        onFilterUpdate(f.query);
      }
    },
    [loading]
  );

  return (
    <ColorSelect
      items={facet.filters
        .sort((a, b) => a.displayName.localeCompare(b.displayName))
        .map((f) => ({
          label: f.displayName,
          onClick: () => onClick(f),
          active: selected?.[f.displayName] !== undefined ? selected[f.displayName] : f.selected,
          hex: [getHexColorFromDisplayName(f.displayName)],
        }))}
    />
  );
};

export default ColorFilter;
